import axios from "axios";
import { store } from "../store";

// Request interceptor to automatically add Authorization token
axios.interceptors.request.use(
  (config) => {
    // Get token from Redux state
    const authState = store.getState().auth;
    const token = authState?.userToken?.token || authState?.userToken;

    if (token) {
      // Set Authorization header if not already set manually
      if (!config.headers.Authorization) {
        config.headers.Authorization = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
